import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Field, reduxForm, propTypes, formValueSelector } from 'redux-form';
import Select from 'react-select';
import DialogTitle from '@material-ui/core/DialogTitle';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Button  } from '@material-ui/core';
import css from './bfm.css';
import { required, normalizeMaxNumber, normalizeNumber, normalizeAccNumber, normalizeASB, maxLength30, bsbMinLength, fixedLengthVal, minLengthVal, maxLengthVal, creditCard } from '../Common/Validation';

const historyOptions = [{ value: 0, label: '0' }, { value: 1, label: '1' }, { value: 2, label: '2' }, { value: 3, label: '3' }, { value: 4, label: '4' }, { value: 5, label: '5' }, { value: 6, label: '6' }, { value: 7, label: '7' }, { value: 8, label: '8' }, { value: 9, label: '9' }, { value: 10, label: '10' }, { value: 11, label: '11' }, { value: 12, label: '12' } ];

const renderField = ({ input, label, meta: { touched, error } }) => (
  <div className={css.dFlexForm}>
    <label className={css.w120}>{label}</label>
    <input {...input} className={[css.formControl, css.flex1, css.mr10].join(' ')} type="text" />
    { touched && (error && <i className={css.validationLabel}>{error}</i>) }
  </div>
);

const renderSelect = ({ input, ...rest }) => <Select  {...input} {...rest} onBlur={() => input.onBlur()} styles={{ menuList:  base => ({ ...base, maxHeight: '115px' }) }} />;

  const renderAccountDetails = (selectedBank, userid) => {

      // For BNZ or Fonterra Feeds
      if (selectedBank && selectedBank.bankId === 40) return (
        <div className={[css.w400, css.smallFont, css.dividerDark].join(' ')}>
          <p>Click the 'Add' button to setup your {selectedBank.bankName} feeds. This will direct you to {selectedBank.bankName} where you will need to login with your {selectedBank.bankName} credentials and give approval for Reckon to access your transactional data.</p>
       </div>
    );

    if (selectedBank && (selectedBank.bankId === 42 || selectedBank.bankId === 46)) return (
      [
        <div className={[css.pb20, css.dFlex, css.contentBetween, css.alignCenter].join(' ')}>
          <div className={css.flex1}><Field name="history" type="text" component={renderSelect} options={historyOptions} /></div>
          <div className={css.pl10}>Months transaction history</div>
        </div>,
        <div className={css.helpText}>On 'Add' you will need to login to {selectedBank.bankName} and authorise the feed</div>
      ]
    );

    if (selectedBank && (selectedBank.bankId === 12 || selectedBank.bankId === 48)) return (
      [
        <Field name="account" label="Card No" type="text" component={renderField} validate={[required]} normalize={(selectedBank.bankId === 48) ? normalizeASB : normalizeNumber} />,
        <Field name="accountName" label="Account Name" type="text" component={renderField} validate={required} />
      ]
    );

    let bsbValidate = [required, bsbMinLength];
    let accountNoValidate = [required];
    let suffixValidate = [required, maxLengthVal[3]];
    
    let normalizeBsb = normalizeMaxNumber[6];
    let normalizeAccount = normalizeAccNumber;
    let normalizeSuffix = normalizeMaxNumber[3];

    if (selectedBank.accountValidation) {
      const { minBSB, maxBSB, minAccount, maxAccount, minSuffix, maxSuffix } = selectedBank.accountValidation;

      bsbValidate = (minBSB === maxBSB) ? [required, fixedLengthVal[maxBSB]] : [required, minLengthVal[minBSB], maxLengthVal[maxBSB]];
      accountNoValidate = (minAccount === maxAccount) ? [required, fixedLengthVal[maxAccount]] :
                            [required, minLengthVal[minAccount], maxLengthVal[maxAccount]];
      suffixValidate = (minSuffix === maxSuffix) ? [required, fixedLengthVal[maxSuffix]] :
                        [required, minLengthVal[minSuffix], maxLengthVal[maxSuffix]];

      normalizeBsb = normalizeMaxNumber[maxBSB];
      normalizeAccount = normalizeMaxNumber[maxAccount];
      normalizeSuffix = normalizeMaxNumber[maxSuffix];
    }
    
      return [
        <Field name="accountName" label="Account Name" type="text" component={renderField} validate={[required, maxLength30]} />,
        (selectedBank.bankName.toLowerCase().indexOf('credit') === -1 &&  ![47].includes(selectedBank.bankId) &&
          <Field name="bsb" label="BSB" type="text" component={renderField} validate={bsbValidate} normalize={normalizeBsb} />),
        <Field name="account" label="Account No" type="text" component={renderField} validate={accountNoValidate} normalize={normalizeAccount} />,
        (selectedBank.country === 'NZ' && ![12, 47, 48].includes(selectedBank.bankId) && 
        <Field name="suffix" label="Suffix No" type="text" component={renderField} validate={suffixValidate} normalize={normalizeSuffix} />)
      ]
    };

let BankFeedForm = (props) => {
    const { handleSubmit, onYodlee, selectedBank, userid, onBack } = props;
    const Heading = (selectedBank.bankId === 40|| selectedBank.bankId === 46) ? ` Feed Setup` : ` Enter bank details`;
    return (
      <div>
        <DialogTitle id="alert-dialog-title" className={css.textCenter}>
          <AssignmentIcon className={css.icon} fontSize="small" />
          {Heading}
        </DialogTitle>
        <div className={[css.textCenter, css.pb20].join(' ')}>
          {`You've selected, `}
          <span className={[css.cardHeading].join(' ')}>
            <strong>{[selectedBank.bankName, <br />]}</strong>
          </span>
        </div>
        <div>
          <form onSubmit={handleSubmit}>
            {renderAccountDetails(selectedBank, userid)}
            {selectedBank.yodleeFeedId && <div className={css.hyperlink}><a href="#" onClick={onYodlee}>Add credit card account feed through Yodlee</a></div>}
            <div className={css.buttonRowHigh}>
              <Button type="button" variant="contained" onClick={onBack}>
                Back
              </Button>
              <Button type="submit" variant="contained" className={[css.mr10, css.floatRight].join(' ')} color="primary">
                Add
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
};

BankFeedForm.propTypes = {
    ...propTypes,
};

renderField.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    label: PropTypes.string
};

BankFeedForm = reduxForm({ form: 'bankFeedForm' })(BankFeedForm);

const selector = formValueSelector('feedWizardForm');

BankFeedForm = connect(state => {
    return { selectedBank: selector(state, 'selectedBank') }; 
  })(BankFeedForm)
  
export default BankFeedForm;



// WEBPACK FOOTER //
// ./src/components/FeedManagment/BankFeedForm.js